/* eslint-disable */
import React, { useContext } from "react";
import { Modal, Button, Table } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { GetafterSalesOrdersDetails } from "../../redux/actions/adminActions";
import CommonDateTime from "./CommonDateTime";
import AmountNumberFormat from "./AmountNumberFormat";
import AfsOrderDraftRenewOrProceedAPI from "../../Api/AfsOrderDraftRenewOrProceedAPI";
import { toast } from "react-toastify";
import wsSend_request from "../../Api/ws/ws_request";
import { WebSocketContext } from "../../App";

const AfsOrderDetailsViewer = (props) => {
  const { AfsOrderViewerModal, setAfsOrderViewerModal, APIcalling, EditAccess, setLoader } = props;
  const { websocket } = useContext(WebSocketContext);

  const { AfterSalesOrderReportDetails, accessToken, device_id } = useSelector(
    (state) => state.adminReducers
  );
  const Dispatch = useDispatch();

  const isDraftOrRenew =
    AfterSalesOrderReportDetails?.order?.order_status === "DRAFT" ||
    AfterSalesOrderReportDetails?.order?.order_status === "RENEW";

  // close modal
  const handleClose = () => {
    setAfsOrderViewerModal({ ...AfsOrderViewerModal, open: false });
    Dispatch(GetafterSalesOrdersDetails({}));
  };

  // total table count
  const TotalTableCount = (list, url) => {
    if (list?.length > 0) {
      let sum = 0;
      for (let i = 0; i < list.length; i++) {
        if (url === "qty") {
          sum += parseInt(list[i]?.qty || 0);
        } else if (url === "partial_qty") {
          sum += parseInt(list[i]?.partial_qty || 0);
        } else if (url === "TaxableAmount") {
          sum += parseFloat(list[i]?.sub_total - list[i]?.sub_gst || 0);
        } else if (url === "sub_gst") {
          sum += parseFloat(list[i]?.sub_gst || 0);
        } else if (url === "sub_total") {
          sum += parseFloat(list[i]?.sub_total || 0);
        }
      }
      return sum;
    }
    return 0;
  };

  const AfsOrderDraftProceed = async (data) => {
    try {
      setLoader(true);
      const response = await AfsOrderDraftRenewOrProceedAPI(
        { order_id: data?.id, action: "proceed" },
        accessToken
      );
      setLoader(false);
      if (response.status !== 200) {
        toast.error(response.message);
      } else {
        toast.info(response.message);
        AfsOrderViewerModal.open = false;
        if (APIcalling) APIcalling();
        handleClose();
      }
    } catch (error) {
      setLoader(false);
      toast.error("Error proceeding draft order");
    }
  };

  const AfsOrderDraftRenew = async (data) => {
    try {
      setLoader(true);
      const response = await AfsOrderDraftRenewOrProceedAPI(
        { order_id: data?.id, action: "renew" },
        accessToken
      );
      setLoader(false);
      if (response.status !== 200) {
        toast.error(response.message);
      } else {
        toast.info(response.message);
        AfsOrderViewerModal.open = false;
        if (APIcalling) APIcalling();
        handleClose();
      }
    } catch (error) {
      setLoader(false);
      toast.error("Error renewing draft order");
    }
  };

  const AfsOrderDraftReject = (data) => {
    const param = {
      transmit: "broadcast",
      url: "afs_order_cancelled_reject_return",
      request: {
        order_id: data?.id,
        order_status: "REJECTED",
      },
      DeviceId: device_id,
    };
    wsSend_request(websocket, param);
    AfsOrderViewerModal.open = false;
    if (APIcalling) APIcalling();
    handleClose();
  };

  return (
    <Modal
      className="OrderDetailsModal"
      id="AfsOrderDetailsModalNew"
      show={AfsOrderViewerModal?.open}
      onHide={handleClose}
    >
      <Modal.Header closeButton>
        <Modal.Title style={{ width: "100%" }}>
          {AfsOrderViewerModal?.Title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="orderDetailsViewr" id="afsContentToPrint">
        {AfterSalesOrderReportDetails !== undefined &&
        Object.keys(AfterSalesOrderReportDetails)?.length > 0 ? (
          <div>
            <Table style={{ marginBottom: "10px" }}>
              <tbody>
                {AfterSalesOrderReportDetails?.order?.order_type !== "CO" && (
                  <tr>
                    <th style={{ fontSize: "14px" }}>Franchise Name</th>
                    <td style={{ fontSize: "14px" }}>
                      {AfterSalesOrderReportDetails?.order?.customer_name}
                    </td>
                  </tr>
                )}
                <tr>
                  <th style={{ fontSize: "14px" }}>Order Code</th>
                  <td style={{ fontSize: "14px" }}>
                    {AfterSalesOrderReportDetails?.order?.order_code}
                  </td>
                </tr>
                <tr>
                  <th style={{ fontSize: "14px" }}>Parent Order Code</th>
                  <td style={{ fontSize: "14px" }}>
                    {AfterSalesOrderReportDetails?.order?.parent_code || "-"}
                  </td>
                </tr>
                <tr>
                  <th style={{ fontSize: "14px" }}>Order Date</th>
                  <td style={{ fontSize: "14px" }}>
                    {CommonDateTime(
                      AfterSalesOrderReportDetails?.order?.created_at,
                      "LL",
                      "show"
                    )}
                  </td>
                </tr>
                <tr>
                  <th style={{ fontSize: "14px" }}>Total Qty</th>
                  <td style={{ fontSize: "14px" }}>
                    {AfterSalesOrderReportDetails?.order?.qty}
                  </td>
                </tr>
                <tr>
                  <th style={{ fontSize: "14px" }}>State</th>
                  <td style={{ fontSize: "14px" }}>
                    {AfterSalesOrderReportDetails?.order?.state?.state_name}
                  </td>
                </tr>
              </tbody>
            </Table>
            <Table className="printTable" bordered>
              <thead>
                <tr>
                  <th style={{ padding: "7px 7px", fontSize: "14px" }}>Sl. No.</th>
                  <th style={{ padding: "7px 7px", fontSize: "14px" }}>Code</th>
                  <th style={{ padding: "7px 7px", fontSize: "14px" }}>Product Name</th>
                  <th style={{ padding: "7px 7px", fontSize: "14px" }}>Rate</th>
                  {isDraftOrRenew && (
                    <th style={{ padding: "7px 7px", fontSize: "14px" }}>Fulfilled Qty</th>
                  )}
                  <th style={{ padding: "7px 7px", fontSize: "14px" }}>Ordered Qty</th>
                  {isDraftOrRenew && (
                    <th style={{ padding: "7px 7px", fontSize: "14px" }}>Pending Qty</th>
                  )}
                  <th style={{ padding: "7px 7px", fontSize: "14px" }}>Taxable Amount</th>
                  <th style={{ padding: "7px 7px", fontSize: "14px" }}>GST</th>
                  <th style={{ padding: "7px 7px", fontSize: "14px" }}>Total</th>
                </tr>
              </thead>
              <tbody>
                {AfterSalesOrderReportDetails?.order_items_list?.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td style={{ padding: "7px 7px", fontSize: "14px" }}>{index + 1}</td>
                      <td style={{ padding: "7px 7px", fontSize: "14px" }}>{item?.product_code}</td>
                      <td style={{ padding: "7px 7px", fontSize: "14px" }}>{item?.product_name}</td>
                      <td style={{ padding: "7px 7px", fontSize: "14px" }}>
                        {parseFloat(item?.price).toFixed(2)}
                      </td>
                      {isDraftOrRenew && (
                        <td style={{ padding: "7px 7px", fontSize: "14px" }}>
                          {item?.partial_qty || 0}
                        </td>
                      )}
                      <td style={{ padding: "7px 7px", fontSize: "14px" }}>{item?.qty}</td>
                      {isDraftOrRenew && (
                        <td style={{ padding: "7px 7px", fontSize: "14px" }}>
                          {item?.qty - (item?.partial_qty || 0)}
                        </td>
                      )}
                      <td style={{ padding: "7px 7px", fontSize: "14px" }}>
                        {AmountNumberFormat(item?.sub_total - item?.sub_gst)}
                      </td>
                      <td style={{ padding: "7px 7px", fontSize: "14px" }}>
                        {AmountNumberFormat(item?.sub_gst)}
                      </td>
                      <td style={{ padding: "7px 7px", fontSize: "14px" }}>
                        {AmountNumberFormat(item?.sub_total)}
                      </td>
                    </tr>
                  );
                })}
                <tr className="totaltd border">
                  <th colSpan={isDraftOrRenew ? 4 : 3} className="text-center">
                    Grand total
                  </th>
                  {isDraftOrRenew && (
                    <td>{TotalTableCount(AfterSalesOrderReportDetails?.order_items_list, "partial_qty")}</td>
                  )}
                  <td>{TotalTableCount(AfterSalesOrderReportDetails?.order_items_list, "qty")}</td>
                  {isDraftOrRenew && (
                    <td>
                      {TotalTableCount(AfterSalesOrderReportDetails?.order_items_list, "qty") -
                        TotalTableCount(AfterSalesOrderReportDetails?.order_items_list, "partial_qty")}
                    </td>
                  )}
                  <td>{AmountNumberFormat(TotalTableCount(AfterSalesOrderReportDetails?.order_items_list, "TaxableAmount"))}</td>
                  <td>{AmountNumberFormat(TotalTableCount(AfterSalesOrderReportDetails?.order_items_list, "sub_gst"))}</td>
                  <td>{AmountNumberFormat(TotalTableCount(AfterSalesOrderReportDetails?.order_items_list, "sub_total"))}</td>
                </tr>
              </tbody>
            </Table>
          </div>
        ) : (
          <>Please Wait...</>
        )}
      </Modal.Body>
      <Modal.Footer>
        <div
          className={`d-flex ${
            isDraftOrRenew && EditAccess ? `justify-content-between` : `justify-content-end`
          } align-items-center w-100`}
        >
          {isDraftOrRenew && EditAccess && (
            <div className="d-flex" style={{ gap: "0.5em" }}>
              <Button
                variant="outline-success"
                onClick={() => AfsOrderDraftProceed(AfterSalesOrderReportDetails?.order)}
              >
                Proceed
              </Button>
              <Button
                variant="dark"
                onClick={() => AfsOrderDraftRenew(AfterSalesOrderReportDetails?.order)}
              >
                Renew
              </Button>
              <Button
                variant="outline-danger"
                onClick={() => AfsOrderDraftReject(AfterSalesOrderReportDetails?.order)}
              >
                Reject
              </Button>
            </div>
          )}
          <div className="d-flex" style={{ gap: "0.5em" }}>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default AfsOrderDetailsViewer;
